module.exports = __webpack_public_path__ + "img/pr-3.795c9728.png";